﻿<script>
  import { getContext } from "svelte";
  import { usersStore } from "../store/Users.js";

  const { close } = getContext("modal");
  const { snackbar } = getContext("app");
  function closeModal() {
    close();
  }
  export let user = { userName: "", email: "", password: "", roles: "" };
  async function save() {
    if (user.userName == "") {
      return;
    }
    var result = await usersStore.save(user);
    if (result.success) {
      snackbar("info", "user saved");
      close();
    } else {
      snackbar("error", result.message);
    }
  }

  $: theroles = $usersStore.roles;
  //usersStore.getRoleNames();
  function init(element) {
    element.focus();
  }
</script>

<div class="modal-header">
  <h5 class="modal-title" id="exampleModalLabel">User</h5>
</div>
<div class="modal-body">
  <label for="naam">Username</label>
  <input
    type="text"
    class="form-control"
    placeholder="username"
    bind:value={user.userName}
    use:init
    required=""
    id="naam"
  />
  <label for="email">Fullname</label>
  <input
    type="text"
    class="form-control"
    placeholder="full name"
    bind:value={user.fullName}
    use:init
    id="email"
    required=""
  />
  <!-- {#if !user.id} -->
  <label for="password">Password</label>
  <input
    type="password"
    class="form-control"
    placeholder="Fill in password only if you want to change it"
    bind:value={user.password}
    use:init
    id="password"
    required=""
  />
  <!-- {/if} -->
  <br />
  <!-- {#if theroles && theroles.length}
    {#each theroles as role}
      <label for={role}>
        <input id={role} type="checkbox" bind:group={user.roles} value={role} />
        {role}
      </label>
      <br />
    {/each}
  {/if} -->
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" on:click={closeModal}>
    Close
  </button>
  <button type="button" class="btn btn-primary" on:click={save}>Save</button>
</div>
